import React, { useEffect, useRef, useState } from "react";
import MainService from "../helpers/services/mainService";
import { ApiService } from "../helpers/services/apiSrevice";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "../lang/TranslationProvider";
import parse from 'html-react-parser';

export default function Investments() {

	const { translate } = useTranslation();
	const { language, languages } = useSelector(state => state.language);

	const [investments, setInvestments] = useState([]);
	const [pagination, setPagination] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [languageId, setLanguageId] = useState(null);
	const [pageContent, setPageContent] = useState(null);

	const targetRef = useRef(null);

	useEffect(() => {
		if (languages && languages.length && language) {
			setLanguageId(languages.find(item => item.isocode2 === language)?.id);
		}
	}, [languages, language]);

	useEffect(() => {
		getInvestments(1);
		getPageContentByKeyName();
	}, [])

	const getPageContentByKeyName = () => {
		MainService.callApi({
			api: ApiService.getPageContentByKeyName,
			data: "KEY_INVESTMENT",
			cb: response => {
				if (response && response.data) {
					setPageContent(response.data);
				}
			},
		});
	}

	useEffect(() => {
		const handleIntersect = (entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					getInvestments(currentPage + 1);
				}
			});
		};
		const observer = new IntersectionObserver(handleIntersect, {
			root: null,
			rootMargin: '0px',
			threshold: 1.0,
		});
		if (targetRef.current) {
			observer.observe(targetRef.current);
		}
		return () => {
			if (targetRef.current) {
				observer.unobserve(targetRef.current);
			}
		};
	}, [currentPage, pagination, isLoading]);


	const getInvestments = (currentPage) => {
		const data = {
			pageNumber: currentPage,
			pageSize: 10,
		}

		setIsLoading(true);
		MainService.callApi({
			api: ApiService.getInvestments,
			data: data,
			cb: response => {
				if (response && response.data) {
					const data = { ...response.data };
					if (data.pagination) {
						setPagination(data.pagination)
					}
					if (data.pagedData && data.pagedData.length) {
						if (currentPage > 1) {
							setInvestments([...investments, ...data.pagedData]);
						} else {
							setInvestments(data.pagedData);
						}
					} else {
						setInvestments([]);
					}
				}
				setIsLoading(false);
				setCurrentPage(currentPage)
			},
			_finally: () => {
				setIsLoading(false);
			},
		});
	}

	return (
		<div className="cont">
			{
				pageContent ?
					<div className="main-page-bunner exhibitions-page-bunner blogs-page-bunner">
						<div className="image pull-left">
							<div className="image-cont">
								{
									pageContent.imagePaths && pageContent.imagePaths.length ?
										<img src={pageContent.imagePaths[0]} alt="image" style={{ height: "100%" }} />
										: <img src="images/our-images/no-image.png" alt="no-image" style={{ height: "100%" }} />

								}
							</div>
						</div>
						<div className="text pull-right">
							<span className="label">{MainService.getValueByLanguageId(pageContent.titles, languageId)}</span>
							<div className="line"></div>
							<div className="name">{parse(MainService.getValueByLanguageId(pageContent.contents, languageId))}</div>
						</div>
						<div className="clear"></div>
					</div>
					: null
			}
			<div className="exhibitions-list exhibitions-list-margin blogs-list-margin blogs-list-margin-no-shadow">
				<div className="exhibition-item-cont mobile">
					<div className="exhibition-item-cont-block" style={{ display: "flex", flexWrap: "wrap", gap: "20px", width: "100%" }}>
						{
							investments && investments.length ?
								investments.map((item, index) => {
									return <div key={index} className="exhibition-item blog-item">
										<div className="image">
											<Link className="image-cont" to={`/library-item/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/library-item/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<p>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</p>
									</div>
								})
								: null
						}
						<div className="clear"></div>
					</div>
				</div>
				<div className="column pull-left desktop">
					{
						investments && investments.length ?
							investments.map((item, index) => {
								if (index % 2 === 0) {
									return <div key={index} className="exhibition-item blog-item">
										<div className="image">
											<Link className="image-cont" to={`/library-item/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/library-item/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<p>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</p>
									</div>
								}
							})
							: null
					}
				</div>
				<div className="column pull-right column-margin-top desktop">
					{
						investments && investments.length ?
							investments.map((item, index) => {
								if (index % 2 === 1) {
									return <div key={index} className="exhibition-item blog-item">
										<div className="image">
											<Link className="image-cont" to={`/library-item/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/library-item/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<p>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</p>
									</div>
								}
							})
							: null
					}
				</div>
				<div className="clear"></div>
				{
					pagination && pagination.totalPages > currentPage && !isLoading && investments.length ?
						<div ref={targetRef} style={{ height: '10px', width: "100%" }} />
						: null
				}
				{
					isLoading ?
						<div style={{
							display: "flex",
							justifyContent: "center",
							marginTop: "80px",
							marginBottom: "80px",
						}}>
							<span className="custom-loader"></span>
						</div>
						: null
				}
			</div>
		</div>
	)

}
